import React, { useState } from "react";
import pb from "lib/pocketbase.js";
import "./Login.css";
import Slide from "../Slide/Slide.js";

export default function Login() {
  const [isVisible, setVisible] = useState(false);
  const [isLogged, setLogged] = useState(false);

  const recordVisit = async (id) => {
    const date = new Date();
    const isoString = date.toISOString();

    const data = {
      user: id,
      time: isoString,
    };

    await pb.collection("visits").create(data);

    return;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const value = e.target[0].value.replace(/\s/g, "");

    pb.collection("users")
      .getFirstListItem(`email="${value}"`)
      .then((res) => {
        let email = res.email;

        if (email === value && res.active === true) {
          recordVisit(res.id);
          setLogged(true);
        } else {
          setVisible(true);
        }
      })
      .catch((error) => {
        setVisible(true);
      });
  };

  const handleClose = () => {
    setVisible(false);
  };
  return (
    <>
      {!isLogged ? (
        <main>
          <h1 className="login_label">Authorized Email</h1>
          <form className="login_form" onSubmit={handleLogin}>
            <input
              type="text"
              name="email "
              placeholder="guest@gmail.com"
              aria-label="Email"
              required
              autocomplete="off"
            />
            <button type="submit" className="submit_btn">
              Login
            </button>
          </form>
        </main>
      ) : (
        <Slide />
      )}
      <div
        className="dialog-container"
        style={isVisible ? { display: "block" } : { display: "none" }}
      >
        <dialog
          id="modal"
          className="modal"
          open={isVisible}
          onClick={handleClose}
        >
          <button
            id="closeModal"
            className="modal-close-btn"
            onClick={handleClose}
          ></button>
          <p>Error !</p>
          <p>Please check back your input.</p>
        </dialog>
      </div>
    </>
  );
}
